import UserService from './user.service';

let upcomingMeetingsCache = null;

export function isMeetingsRoute(route) {
  if (!route) return false;
  const name = route.name || '';
  const path = route.path || '';
  return name === 'Meetings' || path === '/meetings' || path.startsWith('/meetings');
}

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

/** Parse a meeting's date + time into a Date (handles YYYY-MM-DD and DD-MM-YYYY / DD/MM/YYYY). */
function parseMeetingDateTime(m) {
  if (!m || !m.meeting_date) return null;
  const d = String(m.meeting_date).trim();
  let ymd = null;
  if (/^\d{4}-\d{2}-\d{2}/.test(d)) {
    ymd = d.slice(0, 10);
  } else if (/^\d{2}[-/]\d{2}[-/]\d{4}/.test(d)) {
    const p = d.split(/[-/]/);
    ymd = `${p[2]}-${p[1]}-${p[0]}`;
  }
  if (!ymd) return null;
  let hm = '23:59'; // no time → treat as end of that day
  const t = m.meeting_time ? String(m.meeting_time).trim() : '';
  const tm = t.match(/^(\d{1,2}):(\d{2})/);
  if (tm) hm = `${tm[1].padStart(2, '0')}:${tm[2]}`;
  const dt = new Date(`${ymd}T${hm}:00`);
  return isNaN(dt.getTime()) ? null : dt;
}

/** True if the meeting is today or tomorrow (i.e. show from one day before, and on the day). */
export function isMeetingWithinOneDay(item) {
  const m = item && item.meeting ? item.meeting : item;
  const dt = parseMeetingDateTime(m);
  if (!dt) return false;
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endOfTomorrow = new Date(startOfToday.getTime() + 2 * ONE_DAY_MS - 1);
  return dt.getTime() >= startOfToday.getTime() && dt.getTime() <= endOfTomorrow.getTime();
}

/** Fetch upcoming meetings and flag true only if any is within one day. */
export async function fetchUpcomingMeetingsIndicator() {
  const response = await UserService.authPostRequest('get-meetings', { type: 'Upcoming' });
  if (response?.data?.status !== 'success') {
    upcomingMeetingsCache = false;
    return false;
  }
  const list = (response.data.data && response.data.data.list) || [];
  upcomingMeetingsCache = Array.isArray(list) && list.some(isMeetingWithinOneDay);
  return upcomingMeetingsCache;
}

export function getCachedUpcomingMeetingsIndicator() {
  return upcomingMeetingsCache;
}

export function clearUpcomingMeetingsCache() {
  upcomingMeetingsCache = null;
}
